import { createContext, PropsWithChildren, useMemo, useState } from 'react';

interface FormContainerProps {
	disabled?: boolean;
	setDisabled?: React.Dispatch<React.SetStateAction<boolean>>;
}

const FormContainerContext = createContext<FormContainerProps>({
	disabled: true,
});
FormContainerContext.displayName = 'FormContainerContext';

interface FormContainerProviderProps extends PropsWithChildren {
	onSubmit: () => void;
}

const FormContainerProvider = ({ children }: PropsWithChildren) => {
	const [disabled, setDisabled] = useState(false);

	const value = useMemo<FormContainerProps>(
		() => ({
			disabled: disabled,
			setDisabled: setDisabled,
		}),
		[disabled, setDisabled]
	);

	return <FormContainerContext.Provider value={value}>{children}</FormContainerContext.Provider>;
};

export default FormContainerContext;
